import { buildAxiosInstance, buildMakeUseAxios } from "@root/api/api.tools";

export const axiosAction = buildMakeUseAxios(`${import.meta.env.VITE_ACTIVITY_SERVICE_URL}/actions`);
export const axiosActionInstance = buildAxiosInstance(`${import.meta.env.VITE_ACTIVITY_SERVICE_URL}/actions`);
